import { render, staticRenderFns } from "./Anchor.vue?vue&type=template&id=bee08e02&scoped=true&"
import script from "./Anchor.vue?vue&type=script&lang=ts&"
export * from "./Anchor.vue?vue&type=script&lang=ts&"
import style0 from "./Anchor.vue?vue&type=style&index=0&id=bee08e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee08e02",
  null
  
)

export default component.exports